import React, { Component } from 'react';

//other components
import TextBox from "../input_boxes/TextBox";
import { Checkbox } from 'primereact/checkbox';

//generic functions
import {
    isEmpty
} from "../../../functions/generic_functions";

/*
    props:
        checkBoxClassName => to format
        name => name of input
        placeholder => placeholder text
        checked => true/fa;se the checked value of a checkbox
        required => true/false sets the required field for input text
        disabled => true/false disabling box
        onChangeSetParentState => call back function to set the parent state using this state's value
        label => the label of this checkbox, on the right
        otherTextBoxData {
            otherOptionTextBoxValue => the value of the other textbox,
            otherOptionTextBoxName => the name of the other textbox
            otherOptionTextRequired true/false if this field is required => if required, and other checkbox is checked, and empty
            otherOptionTextBoxMaxLength => the max length of the textbox,
            otherOptionTextBoxPlaceholder => the placeholder of the other textbox,
            otherOptionTextBoxClassName => the class name of the other text box
        }
*/

class CustomCheckBox extends Component {

    constructor(props) {
        super(props);

        //rendering ui
        this.renderLabel = this.renderLabel.bind(this);

        //action handlers
        this.handleOnChangeCheckBox = this.handleOnChangeCheckBox.bind(this);

        //helper functions
        this.checkIfDisabledOtherOptionTextBox = this.checkIfDisabledOtherOptionTextBox.bind(this);
        this.checkIfRequiredOtherOptionTextBox = this.checkIfRequiredOtherOptionTextBox.bind(this);

        //ui rendering
        this.renderOtherTextBox = this.renderOtherTextBox.bind(this);
    }

    handleOnChangeCheckBox(event) {
        var currVal = event.target.checked;

        //set the value at the parent if the set function exists
        if (this.props.onChangeSetParentState) {
            this.props.onChangeSetParentState(currVal, this.props.name);
        }
    }

    //renders the label of the checkbox if it is not blank
    renderLabel() {
        if(!isEmpty(this.props.label)) {
            return (
                <span className="checkbox_label_left_padding">
                    <label className="p-checkbox-label">
                        {this.props.label}
                    </label>
                </span>
            );
        }
    }

    checkIfDisabledOtherOptionTextBox() {
        //if it is disabled
        if (this.props.disabled) {
            return true;
        }
        //if the checkbox is not checked, then disable 
        else if (!this.props.checked) {
            return true;
        }
        else {
            return false;
        }
    }

    checkIfRequiredOtherOptionTextBox() {
        //check if textBoxrequired is enabled and if this value is checked
        if (this.props.textBoxRequired
            && this.props.checked) {
            return true;
        }
        else {
            return false;
        }
    }


    //renders the otherText box
    renderOtherTextBox() {
        return (
            <React.Fragment>
                <span className={"checkbox_other_text_box_left_padding"}>
                    <TextBox
                        value={this.props.otherTextBoxData.otherOptionTextBoxValue}
                        name={this.props.otherTextBoxData.otherOptionTextBoxName}
                        placeholder={(!isEmpty(this.props.otherOptionTextBoxPlaceholder) ? this.props.otherOptionTextBoxPlaceholder : "Other")}
                        disabled={this.checkIfDisabledOtherOptionTextBox()}
                        onChangeSetParentState={this.props.onChangeSetParentState}
                        maxLength={this.props.otherTextBoxData.otherOptionTextBoxMaxLength}
                        required={this.checkIfRequiredOtherOptionTextBox()}
                        className={!isEmpty(this.props.otherTextBoxData.otherOptionTextBoxClassName) ? this.props.otherTextBoxData.otherOptionTextBoxClassName : "checkbox_list_other_text_box_format"}
                    />
                </span>
            </React.Fragment>
        );
    }

    render() { 
        return (  
            <React.Fragment>
                <Checkbox 
                    name={this.props.name}
                    checked={this.props.checked}
                    checkBoxClassName={" " + (!isEmpty(this.props.checkBoxClassName) ? this.props.checkBoxClassName : "")}
                    required={(!isEmpty(this.props.required) ? this.props.required : false)}
                    disabled={(!isEmpty(this.props.disabled) ? this.props.disabled : false)}
                    onChange={(e) => this.handleOnChangeCheckBox(e)} 
                />
                {this.renderLabel()} 

                {!isEmpty(this.props.otherTextBoxData) ?
                    this.renderOtherTextBox()
                : null}
            </React.Fragment>
        );
    }
}
 
export default CustomCheckBox;